import { getRequest, patchRequest, postRequest } from "../utils/axios";

export const notificationsService = {
  fetchSettings,
  updateSettings,
  unsubscribeByHash,
};

function fetchSettings(onSuccess, onError) {
  return getRequest(
    "/api/v1/notification-settings/",
    (response) => onSuccess && onSuccess(response),
    (error, response) => onError && onError(error, response)
  );
}

function updateSettings(data, onSuccess, onError) {
  return patchRequest(
    "/api/v1/notification-settings/",
    data,
    (response) => onSuccess && onSuccess(response),
    (error, response) => onError && onError(error, response)
  );
}

function unsubscribeByHash(profileHash, onSuccess, onError) {
  return postRequest(
    "/api/v1/email-unsubscribe/",
    { profile_hash: profileHash },
    (response) => onSuccess && onSuccess(response),
    (error, response) => onError && onError(error, response)
  );
}
